import { createContext } from 'react';

import type { ProductId } from '@trello/paid-account';

import type { BillingQuotes } from './types';

export interface PlanComparisonContextProps {
  onClose?: () => void;
  isModal?: boolean;
  onClickGetStandard?: () => void;
  modalProductCode?: ProductId | '';
  billingQuote?: BillingQuotes;
  hasEndOfTrialFrictionExperience?: boolean;
  onChooseFree?: () => void;
  onChooseStandard?: () => void;
  onKeepPremium?: () => void;
}

export const PlanComparisonContext = createContext<PlanComparisonContextProps>({
  onClose: () => null,
  onClickGetStandard: () => null,
  isModal: false, // only true when nusku billing view is in modal
  modalProductCode: '',
  billingQuote: {} as BillingQuotes,
  hasEndOfTrialFrictionExperience: false,
  onChooseFree: () => null,
  onChooseStandard: () => null,
  onKeepPremium: () => null,
});
